const { map, property, every } = require('lodash');

class RecipeDetailController {
    constructor($state, $window, settings, featureService, analyticsService, breakpointsService, trolleyService) {
        this.$state = $state;
        this.$window = $window;
        this.settings = settings;
        this.featureService = featureService;
        this.analyticsService = analyticsService;
        this.breakpointsService = breakpointsService;
        this.trolleyService = trolleyService;
    }

    $onInit() {
        if (this.recipe && this.recipe.Ingredients) {
            const products = map(this.recipe.Ingredients, property('Product'));
            this.shouldDisplayDisclaimer = products && !every(products, p => (p.IsAvailable && p.IsInStock));
        }

        this.socialMediaEnabled = this.featureService.isEnabled(this.featureService.features.recipeSocialMedia);
        this.printExportEnabled = this.featureService.isEnabled(this.featureService.features.recipePrintExport);
        this.showSubheaderControls = this.socialMediaEnabled || this.printExportEnabled;
        this.analyticsService.push({ data: { recipe: this.recipe }, type: this.analyticsService.mapperTypes.content.recipeDetail });
    }

    // Ideally author information should be coming from the data layer.
    getRecipeAuthor() {
        return this.recipe && this.recipe.TemplateName === 'Jamie_Oliver'
            ? 'Jamie Oliver'
            : 'Woolworths';
    }

    back(event) {
        event.preventDefault();
        this.$window.history.back();
    }

    addAllProductsToTrolley() {
        const products = map(this.recipe.Ingredients, property('Product'));
        this.trolleyService.addItemsToTrolley(products);
        this.analyticsService.pushEvent(this.analyticsService.events.ADD_ALL);
    }
}

const recipeDetailComponentDefinition = {
    bindings: {
        recipe: '<',
    },
    controller: ['$state', '$window', 'Settings', 'FeatureService', 'AnalyticsService', 'BreakpointsService', 'TrolleyService', RecipeDetailController],
    template: require('./recipe-detail.component.html').trim(),
};

module.exports = {
    RecipeDetailController,
    recipeDetailComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/recipe/recipedetail/recipe-detail.component.js